import useTranslation from 'next-translate/useTranslation'
import clsx from 'clsx'

import useAppSelector from '../../../../../store/hooks/useAppSelector'
import {
  clientContextCustomerEmailSelector,
  clientContextCustomerNameSelector,
  clientContextIsAnonymousCustomerSelector,
} from '../../../../clientContext/store/clientContextSelectors'
import { preOrderUserNameSelector } from '../../../../preOrder/store/preOrderSelectors'
import DropdownIcon from '../../../../app/components/DropdownIcon'
import PopoverPanel from '../../../../app/components/popover/PopoverPanel'
import usePopover from '../../../../app/hooks/usePopover'
import { AppTestIds } from '../../../../app/constants'

import useProfileMenuSections from './useProfileMenuSections'
import ProfileMenuSections from './ProfileMenuSections'
import styles from './ProfileMenu.module.scss'

/** Account menu: who is signed in, their pages and sign out */
export default function ProfileMenu() {
  const { t } = useTranslation('common')

  const sections = useProfileMenuSections()
  const { isOpen, close, containerRef, triggerRef, triggerProps, popoverId } =
    usePopover()

  const customerName = useAppSelector(state =>
    clientContextCustomerNameSelector(state, ''),
  )
  const customerEmail = useAppSelector(clientContextCustomerEmailSelector)
  const preOrderUserName = useAppSelector(preOrderUserNameSelector)
  const isAnonymousCustomer = useAppSelector(
    clientContextIsAnonymousCustomerSelector,
  )

  const name = customerName || preOrderUserName || t('auth.guest')
  const subtitle = isAnonymousCustomer
    ? t('auth.guest')
    : t('identity.myAccount')

  return (
    <div className={styles.container} ref={containerRef}>
      <button
        type="button"
        ref={triggerRef}
        className={clsx(styles.trigger, { [styles.isOpen]: isOpen })}
        aria-label={t('identity.accountMenuAria', { name })}
        data-testid={AppTestIds.NavBar.Button.ProfileDropdown}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...triggerProps}
      >
        <span className={styles.triggerText}>
          <span
            className={styles.name}
            data-testid={AppTestIds.NavBar.Button.ProfileName}
          >
            {name}
          </span>
          <span className={styles.subtitle}>{subtitle}</span>
        </span>
        <DropdownIcon isOpen={isOpen} />
      </button>
      {isOpen && (
        <PopoverPanel id={popoverId}>
          <div className={styles.header}>
            <strong className={styles.headerName}>{name}</strong>
            {customerEmail && (
              <span className={styles.email}>{customerEmail}</span>
            )}
          </div>
          <ProfileMenuSections sections={sections} onItemSelected={close} />
        </PopoverPanel>
      )}
    </div>
  )
}
